import {Dialog, type DialogProps, type SxProps, type Theme} from '@mui/material';
import type {ReactNode} from 'react';
import React from 'react';

export interface ModalProps extends Omit<DialogProps, 'title' | 'onClose'> {
    open: boolean;
    onClose: () => void;
    /** feste Breite des Papers (Default 616) */
    width?: number | string;
    /** zusätzliche Paper-Styles, z. B. eine feste Höhe – wird zuletzt gemischt */
    paperSx?: SxProps<Theme>;
    children: ReactNode;
}

export function Modal({open, onClose, width = 616, paperSx, children, ...rest}: ModalProps) {
    return (
        <Dialog
            open={open}
            onClose={(_, reason) => {
                // Backdrop/Esc weiterhin erlaubt – nur ein einheitliches onClose nach außen
                if (reason !== 'backdropClick') onClose();
                else onClose();
            }}
            {...rest}
            // PaperProps, nicht slotProps: Dialog kennt in MUI 5.16 noch keine
            // Paper-Slot-Props – über slotProps gesetzte Styles fielen ersatzlos
            // weg (Breite, Radius, Schatten, Flex-Spalte).
            PaperProps={{
                // Array-Form, damit paperSx auch als Funktion oder Array
                // durchgereicht werden kann statt nur als Objekt
                sx: [
                    {
                        width,
                        maxWidth: '100%',
                        m: 2,
                        borderRadius: 2,
                        overflow: 'hidden',
                        display: 'flex',
                        flexDirection: 'column',
                        // flache MUI-Elevation statt Glanzverlauf
                        boxShadow:
                            '0 11px 15px -7px rgba(0,0,0,.2), 0 24px 38px 3px rgba(0,0,0,.14)',
                    },
                    ...(Array.isArray(paperSx) ? paperSx : [paperSx]),
                ] as SxProps<Theme>,
            }}
        >
            {children}
        </Dialog>
    );
}